import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap'; 
import ApiCaller from '../../constants/ApiCaller'; 
import { showToast, showDangerToast } from '../../constants/toaster'; 
import { uplodateLoading } from '../../../redux/features/common/commonSlice'; 

const GradeUpdateModal = ({ show, onHide, userId, userName, currentGradeId, onSuccess }) => {
    const [grades, setGrades] = useState([]);
    // Initialize with empty string
    const [selectedGradeId, setSelectedGradeId] = useState(""); 
    const dispatch = useDispatch();
    const userData = useSelector((state) => state?.userData);

    // 1. Fetch Grades & Set Initial Value when Modal Opens
    useEffect(() => {
        if (show) {
            // FIX: Convert to String to ensure it matches the <option> value
            const initialValue = currentGradeId ? String(currentGradeId) : "";
            setSelectedGradeId(initialValue);
            
            // Fetch grades if we haven't yet (or fetch every time to be safe)
            if(grades.length === 0) {
                fetchGrades();
            }
        }
    }, [show, currentGradeId]); // Depend on 'show' to reset every time it opens

    const fetchGrades = async () => {
        try {
            const path = "/api/admin-service/grades/grade-list";
            const res = await ApiCaller.post({}, path, userData?.access_token);
            const response = res?.response ? await res.response.json() : null;
            if (response?.status === 200 || response?.successful) {
                setGrades(response?.data || []);
            }
        } catch (error) {
            console.error("Error fetching grades:", error);
        }
    };

    const handleUpdateGrade = async () => {
        if (!selectedGradeId) {
            showToast("Please select a grade");
            return;
        }

        try {
            dispatch(uplodateLoading(true));
            const path = "/api/admin-service/users/grade-update";
            const body = {
                userId: userId,
                gradeId: selectedGradeId,
                updatedBy: userData?.id || userData?.uuid || userData?.emailId || userData?.email
            };

            const res = await ApiCaller.post(body, path, userData?.access_token);
            const response = await res.response.json();

            if (response.status === 200 || response.successful) {
                showToast("Grade updated successfully!");
                
                // FIX: Find the grade NAME to send back to parent for instant update
                const selectedGradeObj = grades.find(g => String(g.id) === String(selectedGradeId));
                const newGradeName = selectedGradeObj ? selectedGradeObj.gradeName : '';

                // Pass both ID and Name back to parent
                if (onSuccess) onSuccess(selectedGradeId, newGradeName); 
                
                onHide(); 
            } else {
                showDangerToast(response.message || "Failed to update grade");
            }
        } catch (error) {
            console.error(error);
            showDangerToast(error.message);
        } finally {
            dispatch(uplodateLoading(false));
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Update Grade</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted mb-2">Assigning grade for: <strong>{userName}</strong></p>
                <Form.Group>
                    <Form.Label>Select Grade</Form.Label>
                    <Form.Control 
                        as="select" 
                        value={selectedGradeId} 
                        onChange={(e) => setSelectedGradeId(e.target.value)}
                    >
                        <option value="">-- Select Grade --</option>
                        {grades.map((g) => (
                            // ensure value is string for comparison
                            <option key={g.id} value={g.id}> 
                                {g.gradeName}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="primary" onClick={handleUpdateGrade}>Update Grade</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GradeUpdateModal;